<template>
    <o-form-select
        blank-option-text=""
        :name="fieldName"
        :value="currentValue"
        v-bind="$attrs"
        @input="on_changed"
        @keydown.enter="refilter"
        v-on="inputListeners"
    >
        <template #first>
            <option :value="null"></option>
        </template>
    </o-form-select>
</template>

<script>
import FilterInputMixin from "./FilterInputMixin.js";

export default {
    name: "OFilterSelect",
    mixins: [FilterInputMixin],
    data() {
        return {
            expression: "eq",
        };
    },
};
</script>
